// import '@hotwired/turbo-rails'
import { Turbo } from '@hotwired/turbo-rails'
import Turn from '@domchristie/turn'
import './member-portal/controllers'
import { fireworks } from './fireworks'
import { redirect_to, turbo_clear_cache } from './stream-actions/turbo'

Turn.start()

Turbo.StreamActions.fireworks = function () {
  fireworks()
}
Turbo.StreamActions.redirect_to = redirect_to
Turbo.StreamActions.turbo_clear_cache = turbo_clear_cache
